import { generateClientId } from '@/shared/lib/ids';

export interface DocumentDraftAttachment {
  attachmentId: string;
  filename: string;
  mimeType: string;
}

export interface DocumentDraftContent {
  bodyMarkdown: string;
  attachments: DocumentDraftAttachment[];
  /**
   * Structured recipient chosen for the draft, owned by the document kind
   * (for example a referral recipient). Faxes leave it unset.
   */
  recipient?: Record<string, unknown>;
}

export interface DocumentDraftModifier {
  userId: string;
  displayName: string | null;
}

export interface DocumentDraft {
  id: string;
  content: DocumentDraftContent;
  createdAt: string;
  updatedAt: string;
  modifiedBy: DocumentDraftModifier;
}

export type DocumentDraftSeed = Partial<DocumentDraftContent>;

export function createDocumentDraft(
  seed: DocumentDraftSeed = {},
  modifiedBy: DocumentDraftModifier
): DocumentDraft {
  const now = new Date().toISOString();
  return {
    id: generateClientId(),
    content: {
      bodyMarkdown: seed.bodyMarkdown ?? '',
      attachments: seed.attachments ?? [],
    },
    createdAt: now,
    updatedAt: now,
    modifiedBy,
  };
}
